import { MENUS_ENDPOINTS } from "./endpoints";
import type { MenuItem, ServerSwapResult } from "./types";
import { apiRequestWithData } from "../shared";

/**
 * Asks the server for a replacement for one dish of the SAVED week. The server reads what else is
 * in the week from the saved menu, so the caller must not have unsaved changes. Nothing is saved.
 */
export default async function swapServerMenuRecipe(args: {
  weekStart: string;
  day: number;
  slot: number;
  course?: MenuItem["course"];
}): Promise<ServerSwapResult> {
  return apiRequestWithData<ServerSwapResult>(MENUS_ENDPOINTS.SWAP, {
    method: "POST",
    body: JSON.stringify({ week_start: args.weekStart, day: args.day, slot: args.slot, course: args.course ?? null }),
  });
}
